import { type TuFunction } from "@src/appV2/i18n/types";
import { TIME_SLOT_RECOMMENDED_START_TIME_RANGE } from "@src/appV2/redesign/DailyView/utils/timeSlotValidation";
import { type TimeSlot } from "@src/appV2/redesign/Shift/types";

export function getTimeSlotChangeMessage(params: {
  timeSlot: TimeSlot;
  isProposal: boolean;
  tu: TuFunction;
}): string {
  const { timeSlot, isProposal, tu } = params;
  const upperCaseTimeSlot = timeSlot.toUpperCase();
  const timeSlotArticle = upperCaseTimeSlot === "AM" ? "an" : "a";
  const range = TIME_SLOT_RECOMMENDED_START_TIME_RANGE[timeSlot];

  if (isProposal) {
    return tu(
      "This will become {{timeSlotArticle}} {{timeSlot}} shift if accepted. {{timeSlot}} shifts start between {{startTime}} and {{endTime}}.",
      {
        values: {
          timeSlotArticle,
          timeSlot: upperCaseTimeSlot,
          startTime: formatTimePart(range.start),
          endTime: formatTimePart(range.end),
        },
      }
    );
  }

  return tu(
    "This will become {{timeSlotArticle}} {{timeSlot}} shift once you save. {{timeSlot}} shifts start between {{startTime}} and {{endTime}}.",
    {
      values: {
        timeSlotArticle,
        timeSlot: upperCaseTimeSlot,
        startTime: formatTimePart(range.start),
        endTime: formatTimePart(range.end),
      },
    }
  );
}

function formatTimePart(timePart: { hour: number; minute: number }): string {
  const amPm = timePart.hour >= 12 ? "PM" : "AM";
  const hour = getDisplayHour(timePart.hour);
  const minute = timePart.minute.toString().padStart(2, "0");

  return `${hour}:${minute} ${amPm}`;
}

function getDisplayHour(hour: number): number {
  if (hour === 0) {
    return 12;
  }

  if (hour > 12) {
    return hour - 12;
  }

  return hour;
}
